// Generated by Melange

import * as Caml_js_exceptions from "melange.js/caml_js_exceptions.js";
import * as Caml_obj from "melange.js/caml_obj.js";
import * as Mapre_web__Web_account_sharing_model from "./web_account_sharing_model.js";
import * as Mapre_wire__Json from "../../shared/wire/json.js";
import * as Stdlib from "melange/stdlib.js";
import * as Stdlib__List from "melange/list.js";
import * as Stdlib__Option from "melange/option.js";
import * as Stdlib__String from "melange/string.js";

function initial(request_id) {
  return {
    items: /* [] */ 0,
    cursor: undefined,
    selected: undefined,
    label: "Devin account",
    pat: "",
    provider: "devin",
    provider_menu: false,
    login: undefined,
    request_id,
    loading: true,
    pending: false,
    message: "",
    sharing: undefined
  };
}

function decode(json) {
  const identity = Mapre_wire__Json.get(json, "identity");
  return {
    id: Mapre_wire__Json.string(json, "id"),
    label: Mapre_wire__Json.string(json, "label"),
    status: Mapre_wire__Json.string(json, "status"),
    version: Mapre_wire__Json.integer(json, "version"),
    provider: Mapre_wire__Json.string(json, "provider"),
    name: Caml_obj.caml_equal(identity, null) ? undefined : Mapre_wire__Json.string(identity, "name")
  };
}

function replace(items, item) {
  if (Stdlib__List.exists((function (x) {
      return x.id === item.id;
    }), items)) {
    return Stdlib__List.map((function (x) {
      if (x.id === item.id) {
        return item;
      } else {
        return x;
      }
    }), items);
  } else {
    return {
      hd: item,
      tl: items
    };
  }
}

function fresh(t, request_id) {
  return {
    items: t.items,
    cursor: t.cursor,
    selected: undefined,
    label: "Devin account",
    pat: "",
    provider: "devin",
    provider_menu: false,
    login: undefined,
    request_id,
    loading: t.loading,
    pending: t.pending,
    message: "",
    sharing: undefined
  };
}

function provider_name(param) {
  switch (param) {
    case "cursor" :
      return "Cursor";
    case "devin" :
      return "Devin";
    case "grok" :
      return "Grok";
    default:
      throw new Caml_js_exceptions.MelangeError(Mapre_wire__Json.Invalid, {
          MEL_EXN_ID: Mapre_wire__Json.Invalid,
          _1: "unsupported_subscription_service"
        });
  }
}

function update(t, login) {
  if (/* tag */ typeof login !== "object" && typeof login !== "function") {
    switch (login) {
      case /* Pending */ 5 :
        return {
          items: t.items,
          cursor: t.cursor,
          selected: t.selected,
          label: t.label,
          pat: t.pat,
          provider: t.provider,
          provider_menu: t.provider_menu,
          login: t.login,
          request_id: t.request_id,
          loading: t.loading,
          pending: true,
          message: "",
          sharing: t.sharing
        };
      case /* Toggle_provider */ 6 :
        return {
          items: t.items,
          cursor: t.cursor,
          selected: t.selected,
          label: t.label,
          pat: t.pat,
          provider: t.provider,
          provider_menu: !t.provider_menu,
          login: t.login,
          request_id: t.request_id,
          loading: t.loading,
          pending: t.pending,
          message: t.message,
          sharing: t.sharing
        };
      case /* Close_provider */ 7 :
        return {
          items: t.items,
          cursor: t.cursor,
          selected: t.selected,
          label: t.label,
          pat: t.pat,
          provider: t.provider,
          provider_menu: false,
          login: t.login,
          request_id: t.request_id,
          loading: t.loading,
          pending: t.pending,
          message: t.message,
          sharing: t.sharing
        };
      default:
        return t;
    }
  } else {
    switch (login.TAG) {
      case /* Open */ 0 :
        return initial(login._0);
      case /* New */ 1 :
        return fresh(t, login._0);
      case /* Edited */ 3 :
        let field = login._0;
        let value = login._1;
        let request_id = login._2;
        const t_items = t.items;
        const t_cursor = t.cursor;
        const t_selected = t.selected;
        const t_label = t.label;
        const t_pat = t.pat;
        const t_provider = t.provider;
        const t_provider_menu = t.provider_menu;
        const t_login = t.login;
        const t_loading = t.loading;
        const t_pending = t.pending;
        const t_sharing = t.sharing;
        const t$1 = {
          items: t_items,
          cursor: t_cursor,
          selected: t_selected,
          label: t_label,
          pat: t_pat,
          provider: t_provider,
          provider_menu: t_provider_menu,
          login: t_login,
          request_id,
          loading: t_loading,
          pending: t_pending,
          message: "",
          sharing: t_sharing
        };
        switch (field) {
          case /* Label */ 0 :
            return {
              items: t_items,
              cursor: t_cursor,
              selected: t_selected,
              label: value,
              pat: t_pat,
              provider: t_provider,
              provider_menu: t_provider_menu,
              login: t_login,
              request_id,
              loading: t_loading,
              pending: t_pending,
              message: "",
              sharing: t_sharing
            };
          case /* Pat */ 1 :
            return {
              items: t_items,
              cursor: t_cursor,
              selected: t_selected,
              label: t_label,
              pat: value,
              provider: t_provider,
              provider_menu: t_provider_menu,
              login: t_login,
              request_id,
              loading: t_loading,
              pending: t_pending,
              message: "",
              sharing: t_sharing
            };
          case /* Provider */ 2 :
            const label = provider_name(value) + " account";
            const init = fresh(t$1, request_id);
            return {
              items: init.items,
              cursor: init.cursor,
              selected: init.selected,
              label,
              pat: init.pat,
              provider: value,
              provider_menu: init.provider_menu,
              login: init.login,
              request_id: init.request_id,
              loading: init.loading,
              pending: init.pending,
              message: init.message,
              sharing: init.sharing
            };
        }
      case /* Selected */ 6 :
        let item = login._0;
        let request_id$1 = login._1;
        return {
          items: t.items,
          cursor: t.cursor,
          selected: item,
          label: item.label,
          pat: "",
          provider: item.provider,
          provider_menu: false,
          login: undefined,
          request_id: request_id$1,
          loading: t.loading,
          pending: t.pending,
          message: "",
          sharing: t.sharing
        };
      case /* Loading */ 7 :
        const init$1 = login._0 ? t : fresh(t, login._1);
        return {
          items: init$1.items,
          cursor: init$1.cursor,
          selected: init$1.selected,
          label: init$1.label,
          pat: init$1.pat,
          provider: init$1.provider,
          provider_menu: init$1.provider_menu,
          login: init$1.login,
          request_id: init$1.request_id,
          loading: true,
          pending: init$1.pending,
          message: "",
          sharing: init$1.sharing
        };
      case /* Loaded */ 8 :
        const items = login._0;
        return {
          items: login._2 ? Stdlib.$at(t.items, items) : items,
          cursor: login._1,
          selected: t.selected,
          label: t.label,
          pat: t.pat,
          provider: t.provider,
          provider_menu: t.provider_menu,
          login: t.login,
          request_id: t.request_id,
          loading: false,
          pending: false,
          message: t.message,
          sharing: t.sharing
        };
      case /* Login_pending */ 9 :
        return {
          items: t.items,
          cursor: t.cursor,
          selected: t.selected,
          label: t.label,
          pat: t.pat,
          provider: t.provider,
          provider_menu: t.provider_menu,
          login: login._0,
          request_id: t.request_id,
          loading: t.loading,
          pending: false,
          message: t.message,
          sharing: t.sharing
        };
      case /* Login_failed */ 10 :
        return {
          items: t.items,
          cursor: t.cursor,
          selected: t.selected,
          label: t.label,
          pat: t.pat,
          provider: t.provider,
          provider_menu: t.provider_menu,
          login: undefined,
          request_id: t.request_id,
          loading: t.loading,
          pending: false,
          message: login._0,
          sharing: t.sharing
        };
      case /* Created */ 11 :
        const item$1 = login._0;
        return {
          items: replace(t.items, item$1),
          cursor: t.cursor,
          selected: item$1,
          label: t.label,
          pat: t.pat,
          provider: t.provider,
          provider_menu: t.provider_menu,
          login: t.login,
          request_id: t.request_id,
          loading: t.loading,
          pending: t.pending,
          message: t.message,
          sharing: t.sharing
        };
      case /* Saved */ 12 :
        const init$2 = fresh(t, login._1);
        return {
          items: replace(t.items, login._0),
          cursor: init$2.cursor,
          selected: init$2.selected,
          label: init$2.label,
          pat: init$2.pat,
          provider: init$2.provider,
          provider_menu: init$2.provider_menu,
          login: init$2.login,
          request_id: init$2.request_id,
          loading: init$2.loading,
          pending: false,
          message: init$2.message,
          sharing: init$2.sharing
        };
      case /* Failed */ 13 :
        return {
          items: t.items,
          cursor: t.cursor,
          selected: t.selected,
          label: t.label,
          pat: t.pat,
          provider: t.provider,
          provider_menu: t.provider_menu,
          login: t.login,
          request_id: t.request_id,
          loading: false,
          pending: false,
          message: login._0,
          sharing: t.sharing
        };
      case /* Updated */ 14 :
        return {
          items: replace(t.items, login._0),
          cursor: t.cursor,
          selected: t.selected,
          label: t.label,
          pat: t.pat,
          provider: t.provider,
          provider_menu: t.provider_menu,
          login: t.login,
          request_id: t.request_id,
          loading: t.loading,
          pending: t.pending,
          message: t.message,
          sharing: t.sharing
        };
      case /* Sharing */ 15 :
        const action = login._0;
        if (/* tag */ typeof action !== "object" && typeof action !== "function") {
          if (action === /* Close */ 0) {
            return {
              items: t.items,
              cursor: t.cursor,
              selected: t.selected,
              label: t.label,
              pat: t.pat,
              provider: t.provider,
              provider_menu: t.provider_menu,
              login: t.login,
              request_id: t.request_id,
              loading: t.loading,
              pending: t.pending,
              message: t.message,
              sharing: undefined
            };
          }
          
        } else if (action.TAG === /* Loading */ 2 && !action._2) {
          return {
            items: t.items,
            cursor: t.cursor,
            selected: t.selected,
            label: t.label,
            pat: t.pat,
            provider: t.provider,
            provider_menu: t.provider_menu,
            login: t.login,
            request_id: t.request_id,
            loading: t.loading,
            pending: t.pending,
            message: t.message,
            sharing: Mapre_web__Web_account_sharing_model.initial(action._0, action._1)
          };
        }
        return {
          items: t.items,
          cursor: t.cursor,
          selected: t.selected,
          label: t.label,
          pat: t.pat,
          provider: t.provider,
          provider_menu: t.provider_menu,
          login: t.login,
          request_id: t.request_id,
          loading: t.loading,
          pending: t.pending,
          message: t.message,
          sharing: Stdlib__Option.map((function (form) {
            return Mapre_web__Web_account_sharing_model.update(form, action);
          }), t.sharing)
        };
      default:
        return t;
    }
  }
}

function can_save(t) {
  if (!t.loading && !t.pending && !Stdlib__Option.fold(false, Mapre_web__Web_account_sharing_model.busy, t.sharing) && Stdlib__String.trim(t.label) !== "") {
    if (t.provider === "devin") {
      return t.pat.length >= 12;
    } else if (t.provider === "cursor") {
      return true;
    } else {
      return t.provider === "grok";
    }
  } else {
    return false;
  }
}

export {
  initial,
  decode,
  update,
  can_save,
  provider_name,
}
/* Mapre_web__Web_account_sharing_model Not a pure module */
